import { connect } from 'react-redux';
import { progress } from '@biw/contests-core';
import { getActiveProgram } from 'dux/router/selectors';
// component
import FinalResults from './final-results';

export const mapStateToProps = ( state ) => {
    const program = getActiveProgram( state );
    return progress.finalResults.finalResultsProps( state, { program } );
};
export default connect( mapStateToProps )( FinalResults );
